import React from 'react';
import LCVProgressTracker from './LCVProgressTracker';
import LCVStageTable from './LCVStageTable';
import LCVTopBar from './LCVTopBar';
import LCVTutorPanel from './LCVTutorPanel';
import LCVViewBoard from './LCVViewBoard';

const LCVStaticLessonStage = ({
  metadata,
  progressData,
  phase,
  activeTerm,
  middleContent,
  tutorText,
}) => {
  if (!progressData || !middleContent) return null;

  return (
    <LCVStageTable
      className="lcv-stage-table-static"
      topLeft={<LCVTopBar metadata={metadata} />}
      topCenter={<LCVProgressTracker data={progressData} phase={phase} />}
      topRight={<div className="lcv-stage-empty" />}
      middleLeft={<LCVViewBoard phase={phase} term={activeTerm} />}
      middleCenter={<div className="lcv-stage-middle-shell">{middleContent}</div>}
      middleRight={<div className="lcv-stage-empty" />}
      bottomLeft={<div className="lcv-stage-empty" />}
      bottom={tutorText ? <LCVTutorPanel text={tutorText} phase={phase} /> : <div className="lcv-stage-empty" />}
    />
  );
};

export default LCVStaticLessonStage;
